export const PAGE_NOT_FOUND_NAME = 'PAGE_NOT_FOUND'

export const EXCEPTION_PAGE = () =>
  import(/** webpackChunkName "initialize" */ '@/views/exception/ExceptionPage.vue')

/** @description 空白 layout */
export const COMMON_LAYOUT = () =>
  import(/** webpackChunkName "initialize" */ '@/views/Layout/CommonLayout.vue')

/** @description default layout */
export const DEFAULT_LAYOUT = () =>
  import(/** webpackChunkName "initialize" */ '@/views/Layout/DefaultLayout.vue')

/** @description 認証関連画面 layout */
export const AUTHORIZATION_LAYOUT = () =>
  import(/** webpackChunkName "initialize" */ '@/views/Layout/AuthorizationLayout.vue')
